import { ForwardRefExoticComponent, forwardRef } from 'react'
import {
  default as MuiFormLabel,
  FormLabelProps as MuiFormLabelProps
} from '@mui/material/FormLabel'

export type FormLabelProps = Pick<
  MuiFormLabelProps,
  | 'children'
  | 'color'
  | 'disabled'
  | 'error'
  | 'filled'
  | 'focused'
  | 'htmlFor'
  | 'id'
  | 'ref'
  | 'required'
>

export const FormLabel: ForwardRefExoticComponent<FormLabelProps> = forwardRef<
  HTMLLabelElement,
  FormLabelProps
>((props: FormLabelProps, ref): JSX.Element => <MuiFormLabel {...props} ref={ref} />)

FormLabel.displayName = 'FormLabel'
